import React, { useCallback, useState } from 'react';
import Form from 'react-bootstrap/esm/Form';

import { usePokCore } from '../../../common/hooks/usePokCore';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import DictionarySelector from '../Selects/DictionarySelector';
import { OptionWithLang } from '../Selects/Selector';
import { ClientWithContactsSearch } from '../Clients/ClientWithContactsSearch';
import { useClientContactsModal } from '../Contacts/useClientContactsModal';
import { FormRow } from '../../../app/components/FormRow';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ClientGroupWithoutContactProps {
  groupId: string;
}

export const ClientGroupWithoutContact: React.FC<
  ClientGroupWithoutContactProps
> = props => {
  const pok = usePokCore();
  const { t, tk } = useTranslation('clientLng');
  const [contactTypeId, setContactTypeId] = useState<string>();
  const [refresh, setRefresh] = useState(false);
  const { open, modal } = useClientContactsModal(() => setRefresh(r => !r));

  const getData = useCallback(
    ((
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) =>
      pok.clientGroups.getWithoutContactTypeByPortion(
        props.groupId,
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        contactTypeId,
      )) as GridGetterFunction,
    [pok.clientGroups, props.groupId, contactTypeId],
  );

  const getCount = useCallback(
    ((filterText: string, filterColumns: string) =>
      pok.clientGroups.getWithoutContactTypeCount(
        props.groupId,
        filterText,
        filterColumns,
        contactTypeId,
      )) as GridCountFunction,
    [pok.clientGroups, props.groupId, contactTypeId],
  );

  return (
    <>
      <Form className="d-grid gap-4 mb-3">
        <FormRow controlId="client" label={t(tk.client.contactType)}>
          <DictionarySelector
            dictionary="Typy kontaktów"
            value={contactTypeId}
            onChange={(option: OptionWithLang) =>
              setContactTypeId(option.value)
            }
            clearable
          />
        </FormRow>
      </Form>
      {contactTypeId && (
        <ClientWithContactsSearch
          getData={getData}
          getCount={getCount}
          onRowClick={open}
          refresh={refresh}
          hideContacts
        />
      )}
      {modal}
    </>
  );
};
